import UsrAdmin from "../Components/admin_component/usr_admin";

const UAccess = () => {
    return ( 
        <UsrAdmin/>
     );
}
 
export default UAccess;